export default () => ({
  candidates: [],
  mainCandidate: null,
  results: {},
  campaignId: null,
  behavioralExpressions: null
})
